export const ErrorTemplate = () => {
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
            }}
        >
            <h1>Error 404. Translations not founded. Please reload page.</h1>
        </div>
    )
};